export const EI_BUTTON_ICON_POSITION = {
    LEFT: 'left',
    RIGHT: 'right',
    NONE: 'none',
    ONLY: 'only',
} as const

export const EI_BUTTON_DEFAULTS = {
    variant: 'primary',
    size: 'sm',
    iconPosition: EI_BUTTON_ICON_POSITION.NONE,
    type: 'button',
    ariaLabelFallback: 'Button',
    fullWidth: false,
} as const
